import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TecnologyProviderEnums } from 'src/app/enum/tecnology-provider-enums';
import { TypePersonEnums } from 'src/app/enum/type-person-enums';
import { EnterpriseModel } from 'src/app/models/management/enterprise.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { AdvancedOptionsEnterpriseComponent } from '../advanced-options-enterprise/advanced-options-enterprise.component';
import { AttachImagesEnterpriseComponent } from '../attach-images-enterprise/attach-images-enterprise.component';
import { EnterpriseCityComponent } from '../../enterprise-city/enterprise-city/enterprise-city.component';

@Component({
  selector: 'app-register-enterprise',
  templateUrl: './register-enterprise.component.html',
  styleUrls: ['./register-enterprise.component.scss'],
  standalone: false
})
export class RegisterEnterpriseComponent implements OnInit {

  @ViewChild('advancedOptions') advancedOptionsModalComponent?: CustomModalComponent | null = null;
  @ViewChild('enterpriseCity') enterpriseCityModalComponent?: CustomModalComponent | null = null;
  @ViewChild('attachImages') attachImagesModalComponent?: CustomModalComponent | null = null;
  branchId: number = 0;
  componentAdvancedOptions = AdvancedOptionsEnterpriseComponent;
  componentEnterpriseCity = EnterpriseCityComponent;
  componentAttachImages = AttachImagesEnterpriseComponent;
  disabledForm: boolean = false;
  enterpriseContract: EnterpriseModel = new EnterpriseModel();
  enterpriseId: number = 0;
  formEnterprise: FormGroup = new FormGroup({});
  icon: string = '';
  isOpened: string | undefined = undefined;
  inputsForAdvancedOptionsModals$ = new BehaviorSubject<any>({
    enterpriseContract: 0,
    permissionUpdatable: false,
    disabledForm: false
  });
  inputsForEnterpriseCityModals$ = new BehaviorSubject<any>({
    enterpriseContract: 0,
    permissionUpdatable: false,
    disabledForm: false
  });
  inputsForAttachImages$ = new BehaviorSubject<any>({
    enterpriseContract: new EnterpriseModel(),
    permissionUpdatable: false,
    disabledForm: false
  });
  listBranches: any[] = [];
  listTecnologyProvider: any[] = [];
  listTypeDocument: any[] = [];
  listTypePerson: any[] = [];
  nameWindow: string = 'Captura Empresas';
  outputAttachImages$ = new Subject<any>();
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  severityState: string = 'success';
  stateEnterprise: string = '';
  subscription: Subscription;
  swElectronicInvoice: boolean = false;
  titleState: string = '';
  url: string = 'enterprise';
  visibleSwGreatContributor: boolean = false;

  constructor(private confirmDialogService: ConfirmDialogService,
    private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private formBuilder: FormBuilder,
    private enterpriseService: EnterpriseService,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private windowService: WindowService) {
    this.validateForm(new EnterpriseModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.enterpriseId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
    this.subscription = this.outputAttachImages$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'updateEnterpriseContract':
          this.enterpriseContract = payload
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeBranch(branchId: number) {
    this.branchId = branchId;
    this.resetContract();
  }

  async changeCode(code: number) {
    this.branchId = this.formEnterprise.get('branchId')?.value;
    if (!this.branchId) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
      return;
    }
    if (!code) {
      this.resetContract();
    } else {
      await this.getEnterpriseByCodeAsync(this.branchId, code);
    }
  }

  changeElectronicInvoice(swElectronicInvoice: boolean) {
    this.swElectronicInvoice = swElectronicInvoice;
    this.validateElectronicInvoice(swElectronicInvoice);
  }

  changeNames() {
    const names = this.formEnterprise.get('names')?.value ?? '';
    const lastNames = this.formEnterprise.get('lastNames')?.value ?? '';
    const businessName = `${names} ${lastNames}`.trim();
    this.formEnterprise.controls['businessName'].patchValue(businessName);
  }

  changeIvaResponsible() {
    const { swIvaResponsible, swSimpleTaxRegime } = this.formEnterprise.value;
    this.visibleSwGreatContributor = swIvaResponsible && !swSimpleTaxRegime;
    if (!this.visibleSwGreatContributor) {
      this.formEnterprise.controls['swGreatContributor'].patchValue(false);
    }
  }

  changeTypePerson(typePersonId: number): void {
    const fieldsToReset: Record<number, Partial<Record<keyof EnterpriseModel, null>>> = {
      [TypePersonEnums.natural]: { businessName: null },
      [TypePersonEnums.juridica]: { names: null, lastNames: null }
    };
    this.disableNamesByTypePerson(typePersonId);
    const fields = fieldsToReset[typePersonId];
    if (fields) {
      this.formEnterprise.patchValue(fields);
    }
  }

  async changeStateEnterprise() {
    const { enterpriseId } = this.enterpriseContract;
    if (!enterpriseId) {
      this.toastHandlerService.showToast('warning', 'Debe crear una empresa.');
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `No tiene permisos para cambiar el estado de la empresa.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    try {
      const response = await firstValueFrom(this.enterpriseService.setActiveEnterprise(enterpriseId));
      this.enterpriseContract = response;
      this.validateForm(this.enterpriseContract);
      const successMessage = response.active ? 'La empresa fue activada exitosamente.'
        : 'La empresa fue desactivada exitosamente.'
      this.toastHandlerService.showToast('success', successMessage);
    } catch (error) {
      console.error('Error al cambiar el estado de la empresa.', error);
    }
  }

  async createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear empresas.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    this.resetContract();
  }

  async createEnterprise(model: EnterpriseModel) {
    try {
      const response = await firstValueFrom(this.enterpriseService.createEnterprise(model));
      this.enterpriseId = response.enterpriseId;
      this.enterpriseContract = response;
      this.validateForm(this.enterpriseContract);
      this.location.replaceState(`/${this.url}/register/${this.enterpriseId}`);
      this.toastHandlerService.showToast('success', `La empresa fue creada exitosamente.`);
    } catch (error) {
      console.error('Error al crear la empresa.', error);
    }
  }

  disableNamesByTypePerson(typePersonId: number): void {
    const getConfig = (type: number) => {
      const configs: Record<number, { enable: string[], disable: string[] }> = {
        [TypePersonEnums.natural]: {
          enable: ['names', 'lastNames'],
          disable: ['businessName']
        },
        [TypePersonEnums.juridica]: {
          enable: ['businessName'],
          disable: ['names', 'lastNames']
        }
      };
      return configs[type];
    };
    const config = getConfig(typePersonId);
    if (config) {
      setTimeout(() => {
        this.formControlStateService.setControlState(this.formEnterprise, config.enable, true);
        this.formControlStateService.setControlState(this.formEnterprise, config.disable, false);
      });
    }
  }

  async deleteEnterprise() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar empresas.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    if (!this.enterpriseId) {
      this.toastHandlerService.showToast('warning', 'Debe crear una empresa.');
      return;
    }
    if (!this.enterpriseContract.active) {
      this.toastHandlerService.showToast('warning', 'No es posible eliminar, la empresa no está activa.');
      return;
    }
    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar la empresa?')) {
      try {
        await firstValueFrom(this.enterpriseService.deleteEnterprise(this.enterpriseId));
        this.createNewRegister();
        this.toastHandlerService.showToast('success', 'La empresa fue eliminada exitosamente.');
      } catch (error) {
        console.error('Error al eliminar la empresa.', error);
      }
    }
  }

  async getAllLists() {
    try {
      const [branches, tecnologyProviders, typeDocuments, typePersons] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.enterpriseService.getAllTecnologyProvidersForSelect()),
        firstValueFrom(this.enterpriseService.getAllTypeDocumentsForSelect()),
        firstValueFrom(this.enterpriseService.getAllTypePersonsForSelect()),
      ]);
      this.listBranches = branches;
      this.listTecnologyProvider = tecnologyProviders;
      this.listTypeDocument = typeDocuments;
      this.listTypePerson = typePersons;
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    this.branchId = this.formEnterprise.get("branchId")?.value;
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    await this.handleEnterpriseNavigation(buttonClick, this.branchId)
  }

  async getDigitVerification(document: string) {
    if (!document || document.trim() === '') {
      this.formEnterprise.patchValue({ digitVerification: null });
      this.toastHandlerService.showToast('error', `El documento ingresado no es válido.`);
    } else {
      try {
        const response = await firstValueFrom(this.enterpriseService.getDigitVerification(document));
        this.formEnterprise.patchValue({ digitVerification: response });
      } catch (error) {
        console.error('Error al obtener el dígito de verificación del documento.', error);
      }
    }
  }

  async getEnterpriseByCodeAsync(branchId: number, code: number) {
    try {
      const response = await firstValueFrom(this.enterpriseService.getEnterpriseByCode(branchId, code));
      this.enterpriseId = response.enterpriseId;
      this.enterpriseContract = response;
      this.validateForm(this.enterpriseContract);
      this.location.replaceState(`/${this.url}/register/${this.enterpriseId}`);
    } catch (error) {
      console.error('Error al buscar la empresa por código:', error);
    }
  }

  async getEnterpriseById() {
    try {
      const response = await firstValueFrom(this.enterpriseService.getEnterpriseById(this.enterpriseId));
      this.branchId = response.branchId;
      this.enterpriseContract = response;
      this.validateForm(this.enterpriseContract);
      this.location.replaceState(`/${this.url}/register/${this.enterpriseId}`);
    } catch (error) {
      console.error('Error al obtener el empresa por id.', error);
    }
  }

  getEnterpriseModel(): EnterpriseModel {
    const model = this.formEnterprise.getRawValue() as EnterpriseModel;
    const modelRecord = model as Record<string, any>;
    const fieldsToNullify = ['names', 'lastNames', 'businessName2',
      'tecnologyProviderUser', 'tecnologyProviderPassword'];
    fieldsToNullify.forEach(field => {
      if (String(modelRecord[field]).trim() === '') {
        modelRecord[field] = null;
      }
    });
    return model;
  }

  async getUserFirstBranchAsync() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
    } catch (error) {
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getAllLists(),
      this.getPermissionProfileByUrl()
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  hasAnyImage(): boolean {
    const { logo, logoFooter, signature } = this.enterpriseContract;
    return !!(logo || logoFooter || signature);
  }

  async handleInitialState() {
    if (this.enterpriseId) {
      await this.getEnterpriseById();
    } else {
      await this.getUserFirstBranchAsync();
      this.createNewRegister();
    }
  }

  async handleEnterpriseNavigation(buttonClick: any, branchId: number) {
    const code = this.formEnterprise.get("code")?.value;
    const actionMap: Record<string, () => Promise<EnterpriseModel>> = {
      first: () =>
        firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId)),
      previus: () =>
        firstValueFrom(this.enterpriseService.getPreviusEnterpriseByKeysAsync(branchId, code)),
      next: () =>
        firstValueFrom(this.enterpriseService.getNextEnterpriseByKeysAsync(branchId, code)),
      last: () =>
        firstValueFrom(this.enterpriseService.getLastEnterpriseByKeysAsync(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.resetContract();
      return;
    }
    try {
      const enterprise = await action();
      this.enterpriseId = enterprise.enterpriseId;
      this.enterpriseContract = enterprise;
      this.validateForm(this.enterpriseContract);
      this.location.replaceState(`/${this.url}/register/${this.enterpriseId}`);
    } catch (error) {
      console.error(`Error al buscar la empresa (${buttonClick.target.id}).`, error);
    }
  }

  async openAdvancedOptions() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para adjuntar imágenes,
        comuniquese con el administrador del sistema.`);
      return;
    }
    this.inputsForAdvancedOptionsModals$.next({
      enterpriseContract: this.enterpriseContract,
      permissionUpdatable: this.permissionUpdatable,
      disabledForm: this.disabledForm
    });
    this.advancedOptionsModalComponent?.show();
  }


  async openEnterpriseCity() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear datos por empresa,
        comuniquese con el administrador del sistema.`);
      return;
    }
    this.inputsForEnterpriseCityModals$.next({
      enterpriseContract: this.enterpriseContract,
      permissionUpdatable: this.permissionUpdatable,
      disabledForm: this.disabledForm
    });
    this.enterpriseCityModalComponent?.show();
  }

  openAttachImages() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para adjuntar imágenes,
        comuniquese con el administrador del sistema.`);
      return;
    }
    this.inputsForAttachImages$.next({
      enterpriseContract: this.enterpriseContract,
      permissionUpdatable: this.permissionUpdatable,
      disabledForm: this.disabledForm
    });
    this.attachImagesModalComponent?.show();
  }

  async send() {
    this.validateFormControls();
    if (this.formEnterprise.valid) {
      const modelEnterprise = this.getEnterpriseModel();
      if (modelEnterprise.swElectronicInvoice && (modelEnterprise.tecnologyProviderId == TecnologyProviderEnums.ninguno ||
        modelEnterprise.tecnologyProviderUser == null || modelEnterprise.tecnologyProviderPassword == null)) {
        this.toastHandlerService.showToast('warning', `Campos de facturación eléctronica no válidos.`);
        return;
      }
      if (this.enterpriseId == 0) {
        await this.createEnterprise(modelEnterprise);
      } else {
        await this.updateEnterprise(modelEnterprise);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'La Sucursal es obligatoria.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      code: {
        required: 'El Código es obligatorio.'
      },
      typeDocumentId: {
        required: 'El Tipo de Documento es obligatorio.',
        min: 'Debe seleccionar un Tipo de Documento válido.'
      },
      document: {
        required: 'El Documento es obligatorio.',
        maxlength: 'El Documento no puede tener más de 15 caracteres.'
      },
      digitVerification: {
        required: 'El Dígito de Verificación es obligatorio.'
      },
      typePersonId: {
        required: 'El Tipo de Persona es obligatorio.',
        min: 'Debe seleccionar un Tipo de Persona válido.'
      },
      names: {
        maxlength: 'Los Nombres no pueden tener más de 75 caracteres.'
      },
      lastNames: {
        maxlength: 'Los Apellidos no pueden tener más de 75 caracteres.'
      },
      businessName: {
        required: 'La Razón Social es obligatoria.',
        maxlength: 'La Razón Social no puede tener más de 150 caracteres.'
      },
      businessName2: {
        maxlength: 'El Nombre Comercial no puede tener más de 150 caracteres.'
      },
      active: {
        required: 'Debe indicar si está Activo o Inactivo.'
      },
      swSelfRetainer: {
        required: 'Debe indicar si es Autorretenedor.'
      },
      swElectronicInvoice: {
        required: 'Debe indicar si usa Facturación Electrónica.'
      },
      tecnologyProviderId: {
        required: 'Debe seleccionar un Proveedor Tecnológico.'
      },
      tecnologyProviderUser: {
        maxlength: 'El Usuario del Proveedor no puede tener más de 250 caracteres.'
      },
      tecnologyProviderPassword: {
        maxlength: 'La Contraseña del Proveedor no puede tener más de 250 caracteres.'
      },
      swStoreInterface: {
        required: 'Debe indicar si usa Interfaz de Tienda.'
      },
      webPage: {
        maxlength: 'La Página Web no puede tener más de 70 caracteres.'
      }
    };
    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formEnterprise.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  resetContract() {
    this.enterpriseId = 0;
    this.enterpriseContract = new EnterpriseModel();
    this.enterpriseContract.branchId = this.branchId;
    this.validateForm(this.enterpriseContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  updateFormState() {
    const { active, swElectronicInvoice, typePersonId } = this.enterpriseContract;
    this.disabledForm = !active;
    this.swElectronicInvoice = swElectronicInvoice;
    this.titleState = active ? 'Activar' : 'Inactivar';
    this.severityState = active ? 'success' : 'danger';
    this.stateEnterprise = active ? 'Activo' : 'Inactivo';
    this.icon = active ? 'pi pi-lock-open' : 'pi pi-lock';
    setTimeout(() => {
      const alwaysRequiredControls = ['branchId', 'code'];
      if (active && this.permissionUpdatable) {
        this.formEnterprise.enable();
        const codeControl = this.formEnterprise.controls['code'];
        this.formEnterprise.controls['digitVerification'].disable();
        this.enterpriseId === 0 ? codeControl.disable() : codeControl.enable();
        this.changeIvaResponsible();
        this.disableNamesByTypePerson(typePersonId);
        this.validateElectronicInvoice(swElectronicInvoice);
      } else {
        this.formEnterprise.disable();
        this.formControlStateService.setControlState(this.formEnterprise, alwaysRequiredControls, true);
      }
    });
  }

  async updateEnterprise(modelEnterprise: EnterpriseModel) {
    this.enterpriseContract.branchId = modelEnterprise.branchId;
    this.enterpriseContract.code = modelEnterprise.code;
    this.enterpriseContract.typeDocumentId = modelEnterprise.typeDocumentId;
    this.enterpriseContract.document = modelEnterprise.document;
    this.enterpriseContract.digitVerification = modelEnterprise.digitVerification;
    this.enterpriseContract.typePersonId = modelEnterprise.typePersonId;
    this.enterpriseContract.names = modelEnterprise.names;
    this.enterpriseContract.lastNames = modelEnterprise.lastNames;
    this.enterpriseContract.businessName = modelEnterprise.businessName;
    this.enterpriseContract.businessName2 = modelEnterprise.businessName2;
    this.enterpriseContract.active = modelEnterprise.active;
    this.enterpriseContract.swSelfRetainer = modelEnterprise.swSelfRetainer;
    this.enterpriseContract.swElectronicInvoice = modelEnterprise.swElectronicInvoice;
    this.enterpriseContract.tecnologyProviderId = modelEnterprise.tecnologyProviderId;
    this.enterpriseContract.tecnologyProviderUser = modelEnterprise.tecnologyProviderUser;
    this.enterpriseContract.tecnologyProviderPassword = modelEnterprise.tecnologyProviderPassword;
    this.enterpriseContract.swStoreInterface = modelEnterprise.swStoreInterface;
    this.enterpriseContract.swGreatContributor = modelEnterprise.swGreatContributor;
    this.enterpriseContract.swSimpleTaxRegime = modelEnterprise.swSimpleTaxRegime;
    this.enterpriseContract.swIvaResponsible = modelEnterprise.swIvaResponsible;
    this.enterpriseContract.webPage = modelEnterprise.webPage;
    try {
      const response = await firstValueFrom(this.enterpriseService.updateEnterprise(this.enterpriseContract));
      this.enterpriseContract = response;
      this.validateForm(this.enterpriseContract);
      this.toastHandlerService.showToast('success', `La empresa fue modificada exitosamente.`);
    } catch (error) {
      console.error('Error al actualizar la empresa.', error);
    }
  }

  validateForm(enterprise: EnterpriseModel) {
    this.formEnterprise = this.formBuilder.group({
      branchId: [enterprise.branchId, [Validators.required, Validators.min(1)]],
      code: [enterprise.code, [Validators.required]],
      typeDocumentId: [enterprise.typeDocumentId, [Validators.required, Validators.min(1)]],
      document: [enterprise.document, [Validators.required, Validators.maxLength(15)]],
      digitVerification: [enterprise.digitVerification, [Validators.required]],
      typePersonId: [enterprise.typePersonId, [Validators.required, Validators.min(1)]],
      names: [enterprise.names, [Validators.maxLength(75)]],
      lastNames: [enterprise.lastNames, [Validators.maxLength(75)]],
      businessName: [enterprise.businessName, [Validators.required, Validators.maxLength(150)]],
      businessName2: [enterprise.businessName2, [Validators.maxLength(150)]],
      active: [enterprise.active, [Validators.required]],
      swSelfRetainer: [enterprise.swSelfRetainer, [Validators.required]],
      swElectronicInvoice: [enterprise.swElectronicInvoice, [Validators.required]],
      tecnologyProviderId: [enterprise.tecnologyProviderId, [Validators.required]],
      tecnologyProviderUser: [enterprise.tecnologyProviderUser, [Validators.maxLength(250)]],
      tecnologyProviderPassword: [enterprise.tecnologyProviderPassword, [Validators.maxLength(250)]],
      swStoreInterface: [enterprise.swStoreInterface, [Validators.required]],
      swIvaResponsible: [enterprise.swIvaResponsible],
      swGreatContributor: [enterprise.swGreatContributor],
      swSimpleTaxRegime: [enterprise.swSimpleTaxRegime],
      webPage: [enterprise.webPage, [Validators.maxLength(70)]]
    });
    this.updateFormState();
  }

  validateElectronicInvoice(swElectronicInvoice: boolean) {
    setTimeout(() => {
      const providerFields = ['tecnologyProviderId', 'tecnologyProviderUser', 'tecnologyProviderPassword'];
      this.formControlStateService.setControlState(this.formEnterprise, providerFields, swElectronicInvoice);
      if (!swElectronicInvoice) {
        this.formEnterprise.patchValue({
          tecnologyProviderId: TecnologyProviderEnums.ninguno,
          tecnologyProviderPassword: null,
          tecnologyProviderUser: null
        });
      }
    });
  }

  validateFormControls() {
    Object.keys(this.formEnterprise.controls).forEach((key) => {
      const control = this.formEnterprise.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
